module.exports = __webpack_public_path__ + "img/logo.c101e078.png";